import React, { useCallback } from 'react';
import type { Product } from 'reactApp/types/Billing';
import { TariffCard } from 'reactApp/ui/TariffCardNew/TariffCard';
import { ETariffCardWidth, TariffCardContentSize } from 'reactApp/ui/TariffCardNew/TariffCard.types';
import { getPrice } from 'reactApp/ui/TariffSectionNew/helpers/getPrice';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import { sendDwh } from 'reactApp/utils/ga';
import { isMonthPeriod } from 'reactApp/utils/Period';

import styles from './FamilyCard.css';

interface FamilyCardProps {
    product: Product;
    activeTab: ETabsName;
    focused: boolean;
    onBuyClick: (product: Product) => void;
}

export const FamilyCard: React.FC<FamilyCardProps> = ({ product, activeTab, focused = false, onBuyClick }) => {
    const [_, __, ___, productMonthPriceAsText, defaultMonthPrice, ____] = getPrice({
        product,
        periodDivider: 'в',
    });
    const buttonAdditionalText = activeTab === ETabsName.year ? 'при покупке на год' : '';
    const buttonText = (
        <div>
            {isMonthPeriod(product.period) && product?.discountPrice && <span className={styles.crossedOldPrice}>{defaultMonthPrice}</span>}
            {productMonthPriceAsText}
        </div>
    );

    const savingInButton = product?.discountPrice && 100 - Math.trunc((product?.discountPrice / product.price) * 100);
    const onClickButton = useCallback(() => {
        sendDwh({ eventCategory: 'tariffs-quota', action: 'modal-tariff-click' });
        onBuyClick(product);
    }, [onBuyClick, product]);

    return (
        <div className={styles.root}>
            <TariffCard
                buttonText={buttonText}
                space={product.space}
                tariffId={product.id}
                onClickButton={onClickButton}
                buttonPrimaryLight={!focused}
                buttonPrimary={focused}
                limeSavingLabel={focused}
                compact
                savingInButton={savingInButton}
                width={ETariffCardWidth.w300}
                contentSize={TariffCardContentSize.small}
                buttonAdditionalText={buttonAdditionalText}
            />
        </div>
    );
};
